import { ActionTree } from 'vuex'
import client from 'axios'
import { NotesState } from '@/store/modules/notes/types'
import { NoteMutations } from '@/store/modules/notes/mutations'
import { apiEndpoints } from '@/constants/api/api'

export enum NotesActions {
  FETCH_NOTES = 'NOTES_REPORTS',
  CREATE_NOTE = 'CREATE_NOTE'
}

export const actions: ActionTree<NotesState, any> = {
  [NotesActions.FETCH_NOTES]: async (context, payload) => {
    context.commit(NoteMutations.TRIGGER_LOADING, true)
    await client({
      method: apiEndpoints.notes.fetchNotes.method,
      url: apiEndpoints.notes.fetchNotes.url,
      params: { customer_id: payload.customerId }
    })
      .then(resp => {
        context.commit(NoteMutations.TRIGGER_LOADING, false)
        if (resp?.data?.data) {
          context.commit(NoteMutations.SET_NOTES, resp.data.data)
        }
      })
      .catch(err => {
        context.commit(NoteMutations.TRIGGER_LOADING, false)
        throw new Error(err)
      })
  },
  [NotesActions.CREATE_NOTE]: async (context, payload) => {
    context.commit(NoteMutations.TRIGGER_LOADING, true)
    await client({
      method: apiEndpoints.notes.createNote.method,
      url: apiEndpoints.notes.createNote.url,
      data: payload
    })
      .then(() => {
        context.commit(NoteMutations.TRIGGER_LOADING, false)
      })
      .catch(err => {
        context.commit(NoteMutations.TRIGGER_LOADING, false)
        throw new Error(err)
      })
  }
}
